import React from 'react';
import './Contact.css';

function Contact() {
  const hours = [
    { day: 'Monday', time: 'Closed', closed: true },
    { day: 'Tuesday', time: '9 AM - 5 PM', closed: false },
    { day: 'Wednesday', time: '9 AM - 5 PM', closed: false },
    { day: 'Thursday', time: '9 AM - 8 PM', closed: false },
    { day: 'Friday', time: '9 AM - 8 PM', closed: false },
    { day: 'Saturday', time: '8 AM - 1 PM', closed: false },
    { day: 'Sunday', time: 'Closed', closed: true },
  ];

  return (
    <main className="contact-page">
      {/* Page Header */}
      <section className="contact-header">
        <div className="contact-header__content">
          <h1 className="contact-header__title">Get In Touch</h1>
          <p className="contact-header__subtitle">We would love to hear from you</p>
        </div>
      </section>

      {/* Contact Content */}
      <section className="section" style={{ backgroundColor: '#faf8f6' }}>
        <div className="container">
          <div className="contact-grid">
            {/* Left Column - Contact Info */}
            <div className="contact-info">
              {/* Address */}
              <div className="contact-card">
                <h3 className="contact-card__title">Visit Us</h3>
                <p className="contact-card__text">
                  49134 Gratiot Ave<br />
                  Chesterfield, MI 48051
                </p>
                <a
                  href="https://www.google.com/maps/search/?api=1&query=42.6611758,-82.8433215"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="contact-card__link"
                >
                  Get Directions &rarr;
                </a>
              </div>

              {/* Phone */}
              <div className="contact-card">
                <h3 className="contact-card__title">Call Us</h3>
                <a href="tel:5869493955" className="contact-card__phone">
                  (586) 949-3955
                </a>
              </div>

              {/* Hours */}
              <div className="contact-card">
                <h3 className="contact-card__title">Hours of Operation</h3>
                <table className="contact-hours">
                  <tbody>
                    {hours.map((item, index) => (
                      <tr key={index} className={item.closed ? 'contact-hours__closed' : ''}>
                        <td className="contact-hours__day">{item.day}</td>
                        <td className={`contact-hours__time ${item.closed ? 'contact-hours__time--closed' : ''}`}>
                          {item.time}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {/* Cancellation Policy */}
              <div className="contact-card contact-card--policy">
                <h4 className="contact-card__policy-title">Cancellation Policy</h4>
                <p className="contact-card__policy-text">
                  Please call to reschedule as soon as possible. We appreciate your consideration
                  for our stylists and other clients who may be waiting for an appointment.
                </p>
              </div>
            </div>

            {/* Right Column - Map */}
            <div className="contact-map">
              <iframe
                title="Epic Hair Salon Location"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2935.0!2d-82.8433215!3d42.6611758!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNDLCsDM5JzQwLjIiTiA4MsKwNTAnMzYuMCJX!5e0!3m2!1sen!2sus!4v1700000000000"
                width="100%"
                height="100%"
                style={{ border: 0, minHeight: '500px' }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          </div>

          {/* Book CTA */}
          <div className="contact-cta">
            <h3 className="contact-cta__title">Ready to book your appointment?</h3>
            <p className="contact-cta__text">
              Schedule online for your convenience, or give us a call.
            </p>
            <a
              href="https://epichairsalon.glossgenius.com/services"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary"
            >
              Book Now
            </a>
          </div>
        </div>
      </section>
    </main>
  );
}

export default Contact;
